import { createSlice } from "@reduxjs/toolkit";

export const accessToken = createSlice({
  name: "user_token",
  initialState: {
    value: { token: "" },
  },
  reducers: {
    updateToken: (state, action) => {
      state.value.token = action.payload ? action.payload : "";
    },
    resetToken: (state, action) => {
      state.value = { token: "" };
    },
  },
});

export const { updateToken, resetToken } = accessToken.actions;

export default accessToken.reducer;
